var currentSiteLocation = window.location.href;

// Object to store selections
var selections = {
  typeOfLiquid: "",
  numberOfCapsules: "",
  washesPerWeek: 0,
  deliveryFrequency: 0
};


// ? Google analytics global variables
var gaUrchinId = "UA-113169257-1";
var isGaLoaded = false;

var trackEventInGa = function(category, action, label) {
  if (isGaLoaded) {
    ga('create', gaUrchinId, 'auto');
    ga('send', 'event', {
      'eventCategory': category,
      'eventAction': action,
      'eventLabel': label
    });
  }
};

var textAnimate = function() {};
var cartCleared = false;

var clearTheCart = function() {
  $.ajax({
    type: "POST",
    url: "/cart/clear.js",
    dataType: "json",
    success: function () {
      cartCleared = true;
      return true;
    },
    error: function () {
      return false;
    }
  })
}

// Recharge code
$(document).ready(function () {

  // Utility function to prevent browser adblockers and GA excluders - only used on GA event tracking above
  function checkGaIsLoaded() {
    if (typeof ga !== 'undefined') {
      isGaLoaded = true;
    } else {
      setTimeout(checkGaIsLoaded, 500);
    }
  }

  checkGaIsLoaded();

  // Hide checkout button to prevent user eaching cart before they should
  $("#checkout-button").hide();
  $(".cart-loader").removeClass("visible");


  // The old way to check for the Shopify toekn - this was updated with the new Recharge Workflows, which is in theme.liquid reChargeProcessCart

  // $(document).on('cart.requestStarted', function (event, cart) {
  //   $("#checkout-button").hide();
  //   $(".cart-loader").addClass("visible");
  // });

  // $(document).on('cart.requestComplete', function (event, cart) {
  //   cart.item_count == 1 ?
  //     goToCheckout() : console.log('bad');
  // });

  // // Redirect to checkout page on cart population
  // function get_cookie(name) {
  //   return (document.cookie.match('(^|; )' + name + '=([^;]*)') || 0)[2]
  // };

  // function goToCheckout() {
  //   do {
  //     token = get_cookie('cart');
  //   }
  //   while (token == undefined);

  //   try {
  //     var ga_linker = ga.getAll()[0].get('linkerParam')
  //   } catch (err) {
  //     var ga_linker = ''
  //   }
  //   // myshopify_domain and customer_param are both declared inline in theme.liquid as they require access to global liquid variables not available with JS
  //   var checkout_url = "https://checkout.rechargeapps.com/r/checkout?myshopify_domain=" + myshopify_domain + "&cart_token=" + token + "&" + ga_linker + "&" + customer_param;
  //   window.location.href = checkout_url;
  // };

  // Animates the text for number of days
  textAnimate = function () {
    var holder = [];
    $("p.to-hide").hide();
    number();
    setTimeout(function () {
      go();
    }, 1500);
    var go = function () {
      sliceNum();
      turnTheSlot();
      reset();
    }

    function number() {
      var num = (selections.deliveryFrequency);
      $("p.to-hide").text(num);
      if (num <= 9) {
        $("#1").hide();
      } else {
        $("#1").show();
      }
      if (num <= 99) {
        $("#2").hide();
      } else {
        $("#2").show();
      }
    }

    function sliceNum() {
      var theNUM = $("p.to-hide").text();
      for (var i = 0; i < 6; i++) {
        var valu = theNUM.slice(i, i + 1);
        holder.push(valu);
      }
    }

    function reset() {
      holder.length = 0;
    }

    function turnTheSlot() {
      for (var i = 0; i < 6; i++) {
        var theValue = holder[i];
        var margin = 100 * theValue;
        var randomise = Math.floor(Math.random() * 1000);
        var secondOrder = function () {
          $("#" + i + "").css("margin-top", "-" + margin + "px");
        }
        secondOrder();
      }
    }
  }

});